module.exports = __webpack_public_path__ + "static/ff-clan-std-news-464dc01bbc532601f0e2972466497b81.woff2";